import { lazy, Suspense } from "react";
import CircularLoader from "../custom/circularLoader/circularLoader";

const Main = lazy(() => import("../components/changePassword/main"));

const ChangePassword = () => {
    return (
        <Suspense fallback={<CircularLoader />}>
            <Main />
        </Suspense>
    )
}
export default ChangePassword